<template>
    <div class="invitados_no_confirmados">
        <h2 class="subheading grey--text">{{$t('invitados_no_confirmados')}}</h2>
        <v-container class="my-5">
        <!--    Diálogo Modal Persistente para mostrar la Info de Residente Principal y Residentes    -->
        <v-dialog v-model="dialogInfoGuest" scrollable max-width="1000px">
            <v-card class="elevation-5">
                <v-toolbar
                    dark
                    color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-home-edit
                        </v-icon>
                        {{$t('confirmar_identidad')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoGuest = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="userInfo !== null">
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <v-layout row wrap>
                                <v-flex
                                        class="edge pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="userInfo.avatar"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="edge pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="userInfo.ine_frente"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="userInfo.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="userInfo.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="userInfo.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="userInfo.celular"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 class="text-xs-center">
                                  {{$t('msg_know_guest')}}
                                  <v-radio-group
                                      class="justify-center"
                                      row
                                      v-model="confirm"
                                      name="confirm"
                                      :mandatory="false"
                                  >
                                    <v-radio
                                        class="pl-3 pr-3"
                                        :label="$t('Si')"
                                        value=true
                                        outlined
                                    ></v-radio>
                                    <v-radio
                                        class="pl-3 pr-3"
                                        label="No"
                                        value=false
                                        outlined
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                            </v-layout>
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions  class="justify-center">
                    <v-btn
                            class="align-center"
                            color="primary"
                            large
                            :loading="loading"
                            @click="activateDeleteGuest(userInfo.temporalToken)"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal  Confirmar   -->
        <v-dialog v-model="dialogConfirm" max-width="380">
          <v-card class="justify-center">
            <v-card-title
                class="warning display-1 text--primary justify-center"
                primary-title
            >
              {{$t('confirmar_identidad')}}
            </v-card-title>
            <v-card-text class="text-xs-center">
              Selecciona <b>Sí</b> o <b>No</b>, para confirmar la Identidad.
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="dialogConfirm = false">{{$t('aceptar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialog_seguro"
                persistent
                width="300"
        >
            <v-card class="justify-center">
                <v-card-title
                        class="warning display-1 text--primary justify-center"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text class="text-xs-center">
                    <h4>{{$t('pgt_seguro')}}</h4><br>
                    <h5>{{$t('msg_guest_corrections')}}</h5>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="dialog_seguro = false">No</v-btn>
                    <v-spacer/>
                    <v-btn color="primary" @click="eliminar_invitado()">{{$t('Si')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('invitados_no_confirmados')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_invitados_no_confirmados"
                            :items="invitados_no_confirmados"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
<!--                            <td class="justify-center">-->
<!--                                <v-icon-->
<!--                                        medium-->
<!--                                        color="red"-->
<!--                                        @click="deleteDialog = true, idGuestDelete = item.id"-->
<!--                                >-->
<!--                                    delete-->
<!--                                </v-icon>-->
<!--                            </td>-->
                            <td v-if="props.item.ine_frente !== null" class="justify-center">
                                  <v-btn
                                          @click="userInfo = props.item, dialogInfoGuest = true, confirm = null"
                                          block
                                          color="primary">
                                      {{$t('validar')}}
                                  </v-btn>
                            </td>
                            <td v-else class="justify-center">
                                  <v-btn
                                          v-show="props.item.roll === 0"
                                          disabled
                                          block
                                          @click="userInfo = props.item, dialogInfoGuest = true"
                                          color="primary">
                                      {{$t('validar')}}
                                  </v-btn>
                                  <v-alert
                                          class="mr-2"
                                          v-show="props.item.roll === 15"
                                          type="warning">
                                      {{ $t('msg_no_register_provider_yet1')}}<br>
                                      {{ $t('msg_no_register_provider_yet2')}}
                                  </v-alert>
                            </td>
                            <td>{{ props.item.first_name === '' ? 'Sin Registrar' : props.item.first_name }}</td>
                            <td>{{ props.item.last_name === '' ? 'Sin registrar' : props.item.last_name }}</td>
                            <td>{{ props.item.celular }}</td>
                            <td>{{ props.item.email === null ? 'Sin Registrar' : props.item.email }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Empleados')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)

    export default {
        name: "invitados_no_confirmados",
        created: function(){
            this.get_invitados_no_confirmados()
        },
        data: () => ({
            search: '',
            invitados_no_confirmados: [],
            headers: [],
            userInfo: [],
            confirm: null,
            dialogConfirm: false,
            loading: false,
            step: 1,
            dialogInfoGuest: false,
            dialog_seguro: false,
            loading_data_invitados_no_confirmados: false
        }),
        beforeUpdate(){
            this.headers = [
                // {
                //   text: this.$t('acciones'),
                //   align: 'left',
                //   value: 'action',
                //   sortable: false
                // },
                {
                  text: this.$t('validar'),
                  align: 'center',
                  sortable: true,
                  value: 'avatar'
                },
                {
                    text: this.$t('Nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('Apellido'),
                    align: 'left',
                    sortable: true,
                    value: 'apellido'
                },
                {
                    text: this.$t('celular'),
                    align: 'left',
                    sortable: true,
                    value: 'celular'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'email'
                },
            ]
        },
        methods:{
            get_invitados_no_confirmados: function(){
                this.loading_data_invitados_no_confirmados = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/GetUsers/NoActivated',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status === 204) {
                            this.invitados_no_confirmados = []
                        } else {
                            this.invitados_no_confirmados = response.data
                        }
                        this.loading_data_invitados_no_confirmados = false
                    })
                    .catch(error => {
                        this.loading_data_invitados_no_confirmados = false
                        console.log(error)
                    })

            },
            activateDeleteGuest (token) {
              if (this.confirm === null) {
                this.dialogConfirm = true
              }
              if (this.confirm === 'true') {
                console.log('Activar Invitado')
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/activateUser/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data:{
                        usrToken: token
                    }
                };
                axios(config)
                .then(ok => {
                  console.log(ok)
                  this.loading = false
                  this.get_invitados_no_confirmados()
                  this.$store.commit('snackbar_activate_true')
                  this.$store.commit('snackbar_change_message', this.$t('msg_user_validated'))
                  this.dialogInfoGuest = false
                  setTimeout(this.clear, 3000)
                })
                .catch(error => {
                  this.loading = false
                  console.log(error)
                })
                .finally(() => (this.loading = false))
              } else {
                if (this.confirm === 'false') {
                    this.dialog_seguro = true
                }
              }
            },
            eliminar_invitado(){
                //llamar al endpoint para eliminar usuario
                const config = {
                    method: 'POST',
                    url: 'https://empresa-service.intrare.app/NoActivateUser/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data:{
                        token: this.userInfo.temporalToken,
                        cellNumber: this.userInfo.celular
                    }
                }
                axios(config)
                .then(ok => {
                  console.log(ok)
                  this.dialog_seguro = false
                  this.get_invitados_no_confirmados()
                  this.$store.commit('snackbar_activate_true')
                  this.$store.commit('snackbar_change_message', this.$t('msg_user_invalidated'))
                  this.dialogInfoGuest = false
                  setTimeout(this.clear, 3000)
                })
                .catch(error => {
                  console.log(error)
                })
            },
            clear () {
              this.$store.commit('snackbar_change_color', 'success')
              this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>


<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
